import {
  DISCLOSURE_IDS,
  DISCLOSURE_TYPES,
  DISCLOSURE_ID_ICON_MAPPING,
  DISCLOSURE_TYPE_ICON_MAPPING,
  DISCLOSURE_CATEGORY_ICONS,
  DISCLOSURE_ICON_NAMES,
} from './constants';

/**
 * Obtains the bamboo icon name for the disclosure, based on the id and type. If there's no match, it will fallback to `GenericDisclosures` icon
 * @param {string|number} disclosureId the id of the disclosure
 * @param {string} disclosureType the disclosure type
 * @returns {string} the icon name for the disclosure
 */
const getDisclosureIcon = (disclosureId, disclosureType) => {
  return (
    DISCLOSURE_ID_ICON_MAPPING[disclosureId] ||
    DISCLOSURE_TYPE_ICON_MAPPING[disclosureType] ||
    DISCLOSURE_CATEGORY_ICONS.RESTRICTIONS_LIMITATIONS
  );
};

export {
  getDisclosureIcon,
  DISCLOSURE_IDS,
  DISCLOSURE_ID_ICON_MAPPING,
  DISCLOSURE_ICON_NAMES,
  DISCLOSURE_TYPE_ICON_MAPPING,
  DISCLOSURE_CATEGORY_ICONS,
  DISCLOSURE_TYPES,
};
